import { render } from "./OcrTabs.vue?vue&type=template&id=121e98ae"
import script from "./OcrTabs.vue?vue&type=script&lang=js"
export * from "./OcrTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__